import React, { useState, useContext, useEffect } from "react";
import "./cartPage.css"
import { Context } from "../../app";
import nexum from "../../assets/shop/orbitShop.png"
import nexumMini from "../../assets/shop/orbitMiniShop.png"
import { useNavigate } from "react-router-dom";
import { Mixpanel } from "../../Mixpanel";
import axios from "axios";

import CartReminder from "../cartReminder/cartReminder";
import Image from "../Image/image";


function CartPage(props) {
    
    const [cartReminder, setCartReminder] = useState(true)
    const [email, setEmail] = useState(localStorage.getItem("email")?localStorage.getItem("email"):"")
    const [error, setError] = useState(false)
    const shop = useContext(Context)
    let navigate = useNavigate()

    useEffect(()=>{
        if (shop.mpid) {
            axios({
                url:shop.url+"mixpanel",
                method:"POST",
                headers:{"Content-Type":"application/json"},
                data:{
                    event:"cartOpen",
                    properties:{cart:shop.cart},
                    id:shop.mpid
                }
            }).then((res)=>{

            })
            .catch((e)=>console.log(e))
        }
    },[])

    const changeEmail = (ev)=>{
        if (ev.target.value) {
            setError(false)
        }
        setEmail(ev.target.value)
        localStorage.setItem("email", ev.target.value)
    }

    const decideCheckout = ()=>{
        if (email) {
            setError(false)
            navigate('/checkout')
        }
        else {
            setError(true)
        }
    }

    // console.log(shop.total, typeof shop.total, Number(parseFloat(shop.total).toFixed(2)))

    return(
        <div  className="cart-page">
            
            <div className="cart-page-container">
                
                {/* <p>Total: {shop.sanitizeNumber(shop.total)}</p> */}
                <p>
                    Cart Summary {`(${shop.cart.reduce((a,b)=>a+b.quantity, 0)})`}
                    <i onClick={()=>shop.setShowCart(false)} className="material-icons cart-close">close</i>
                </p>
                {
                    shop.cart.map((item)=>{
                        return(
                            <div className="cart-page-item">
                                <div className="cart-page-item-pic">
                                    {
                                        <Image 
                                            width={item.id.includes("BUN")?"250px":"250px"}
                                            src={`products/${item.id}.png`}
                                        />
                                    }
                                    <p>{item.quantity}</p>
                                </div>
                                
                                <div className="cart-page-item-details">
                                    <p>{item.name}</p>
                                    <div className="edit-quantity">
                                        <i style={{color:"gray"}} onClick={()=>shop.removeCart(item.id)} className="material-icons">remove</i>
                                        <p style={{color:"gray"}}>{item.quantity}</p>
                                        <i style={{color:"gray"}} onClick={()=>shop.addCart(item.id, null, null, null)} className="material-icons">add</i>
                                    </div>
                                </div>
                                <p className="item-total">
                                   <s>${shop.sanitizeNumber(item.quantity*item.price)}</s> ${shop.sanitizeNumber(item.discount*item.quantity)}
                                </p>
                            </div>
                        )
                    })
                }
                <div className="checkout-items-total">
                    <p className="items-total-text">Total</p>
                    <p className="items-total">USD <s>${shop.sanitizeNumber(shop.total)}</s> <span>${shop.sanitizeNumber(shop.discount)}</span></p>
                </div>
                <div className="cart-page-buttons">
                    {/* <CartReminder 
                        setCartReminder={setCartReminder}
                        email={email}
                        setEmail={setEmail}
                        changeEmail={changeEmail}
                        error = {error}
                    /> */}
                    <button onClick={()=>{
                        shop.setShowCart(false)
                        navigate("/checkout")
                        
                    }} className="checkout--btn">Secure Checkout</button>
                    <div className="badges-cartPage">
                        {/* <img src="https://www.paypalobjects.com/digitalassets/c/website/marketing/apac/C2/logos-buttons/optimize/logo-center-other-options-blue-secured-pp.png" border="0" alt="Secured by PayPal"></img> */}
                        {/* <img width={"110px"} src="https://www.paypalobjects.com/digitalassets/c/website/marketing/apac/C2/logos-buttons/optimize/logo-center-other-options-white-secured-pp.png" border="0" alt="Secured by PayPal"></img> */}

                        {/* <img width={"80px"} src="https://www.paypalobjects.com/webstatic/mktg/Logo/pp-logo-200px.png" alt="Check out with PayPal" /> */}
                    </div>
                </div>
                
                
            </div>
            
        </div>
    )
}

export default CartPage